
document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('QuoteRequestForm');
  if (!form) return;

  var successMessage = form.querySelector('.quote-request-form__status--success');
  var errorMessage = form.querySelector('.quote-request-form__status--error');

  if (successMessage) {
    sessionStorage.removeItem('brokster_quote_submitted');
    setTimeout(function () {
      successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 150);
    return;
  }

  if (errorMessage) {
    sessionStorage.removeItem('brokster_quote_submitted');
    setTimeout(function () {
      errorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 150);
    return;
  }

  form.addEventListener('submit', function () {
    try { sessionStorage.setItem('brokster_quote_submitted', '1'); } catch(e) {}
  });

  try {
    if (sessionStorage.getItem('brokster_quote_submitted') === '1') {
      var wrapper = document.getElementById('QuoteRequestFormWrapper');
      if (wrapper && !wrapper.querySelector('.quote-request-form__status')) {
        var banner = document.createElement('div');
        banner.className = 'quote-request-form__status quote-request-form__status--success';
        banner.setAttribute('role', 'status');
        banner.textContent = 'Votre demande de devis a bien été envoyée. Nous revenons vers vous rapidement.';
        form.insertBefore(banner, form.firstChild);
        sessionStorage.removeItem('brokster_quote_submitted');
        setTimeout(function () {
          banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 150);
      }
    }
  } catch(e) {}
});
